import { BaseMapper } from "types/shared/mapper";
export function getCurrencyConfig(code) {
  let minFractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  let maxFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  if (code === 'PEN') {
    return {
      prefix: 'PEN ',
      currency: 'PEN',
      locale: 'es-PE',
      minFractionDigits,
      maxFractionDigits,
      symbol: 'S/'
    };
  }
  return {
    prefix: 'USD ',
    currency: 'USD',
    locale: 'en-US',
    minFractionDigits,
    maxFractionDigits,
    symbol: '$'
  };
}
export const CurrencyCode = Object.freeze({
  ARS: "ARS",
  USD: "USD",
  AUD: "AUD",
  BOB: "BOB",
  BRL: "BRL",
  CAD: "CAD",
  CHF: "CHF",
  CLP: "CLP",
  COP: "COP",
  CRC: "CRC",
  EUR: "EUR",
  FJD: "FJD",
  GBP: "GBP",
  MXN: "MXN",
  PEN: "PEN",
  PHP: "PHP",
  PYG: "PYG",
  UYU: "UYU"
});
export class CurrencyModel extends BaseMapper {
  fromRaw(raw) {
    this.symbol = raw.symbol;
    this.cash = raw.cash;
    this.cashFinanced = raw.cash_financed;
    this.formattedCash = raw.formatted_cash;
    this.formattedCashFinanced = raw.formatted_cash_financed;
    return this;
  }
  toRaw() {
    return CurrencyModel.toRaw(this);
  }
  static fromRaw(raw) {
    return new CurrencyModel().fromRaw(raw);
  }
  static toRaw(currency) {
    return {
      symbol: currency.symbol,
      cash: currency.cash,
      cash_financed: currency.cashFinanced,
      formatted_cash: currency.formattedCash,
      formatted_cash_financed: currency.formattedCashFinanced
    };
  }
}